<template>
  <div :style="containerStyle">
    <img :style="closeStyle" :src="iconCloseBlack" alt="close" @click="hideWidget" />
    <h5 :style="titleStyle">{{ settings.title }}</h5>
    <p :style="messageStyle">{{ settings.body }}</p>
  </div>
</template>

<script>
import { iconCloseBlack } from '../Constants'

const containerStyle = {
  position: 'fixed',
  bottom: 0,
  left: '20px',
  width: 'calc(100% - 70px)',
  maxWidth: '360px',
  padding: '20px',
  background: '#fff',
  backgroundColor: 'rgba(255,255,255,0.93)',
  boxShadow: '0 0 4px 2px rgba(0, 0, 0, .2)',
  borderRadius: '5px',
  display: 'block',
  transform: 'translateY(100%)',
  transition: 'transform 1s',
  zIndex: '9999'
}

const titleStyle = {
  color: '#EC1000',
  fontSize: '18px',
  margin: '0 0 10px',
  paddingBottom: '5px',
  borderBottom: '1px solid #141617',
  fontFamily: 'sans-serif'
}

const messageStyle = {
  color: '#141617',
  margin: 0,
  fontFamily: 'sans-serif'
}

const closeStyle = {
  position: 'absolute',
  right: '10px',
  top: '10px',
  cursor: 'pointer'
}

export default {
  name: 'NoticeBubble',
  props: {
    settings: { type: Object, required: true }
  },
  data() {
    return {
      containerStyle,
      titleStyle,
      messageStyle,
      iconCloseBlack,
      closeStyle
    }
  },

  created() {
    setTimeout(() => {
      this.containerStyle.transform = 'translateY(0)'
    }, 500)
  },

  methods: {
    hideWidget() {
      this.containerStyle.display = 'none'
    }
  }
}
</script>
